import React from 'react'
import Navbar from './Navbar'
import HeroSection from './Herosection'
import Herosection2 from './Herosection2'

const Merger = () => {
  return (
    <>
    <Navbar />
    <HeroSection />
    <Herosection2 />
    </>
  )
}

export default Merger